import { render, staticRenderFns } from "./index.vue?vue&type=template&id=662fcbfe&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=662fcbfe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662fcbfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('662fcbfe')) {
      api.createRecord('662fcbfe', component.options)
    } else {
      api.reload('662fcbfe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=662fcbfe&scoped=true", function () {
      api.rerender('662fcbfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulk-grant/index.vue"
export default component.exports